<template>
  <div class="mb-4">
    <p class="is-size-7 has-text-grey mb-1">
      {{ $t('onboarding.steps.stepOf', { current: currentStep, total: steps.length }) }}
      &middot;
      <span class="has-text-weight-semibold">{{ $t(steps[currentStep - 1].labelKey) }}</span>
    </p>
    <progress
      class="progress is-info is-small"
      :value="currentStep - 1"
      :max="steps.length"
    ></progress>
  </div>
</template>

<script>
export default {
  name: 'OnboardingProgress',
  props: {
    currentStep: {
      type: Number,
      required: true,
      validator: val => val >= 1 && val <= 4
    }
  },
  data () {
    return {
      steps: [
        { number: 1, labelKey: 'onboarding.steps.step1' },
        { number: 2, labelKey: 'onboarding.steps.step2' },
        { number: 3, labelKey: 'onboarding.steps.step3' },
        { number: 4, labelKey: 'onboarding.steps.step4' }
      ]
    }
  }
}
</script>

<style scoped>
progress::-webkit-progress-value {
  transition: width 0.4s ease;
}
progress::-moz-progress-bar {
  transition: width 0.4s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/OnboardingProgress.vue